import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { DropdownSelect as CoreDropdownSelect } from '@vds-core/selects';
import { calculateSpacing, colors } from '@vds-core/theme';
import { TypographyConfig, Micro, Body, BodyConfig } from '@vds-core/typography';
import { IconData } from '@vds-core/icons';

var DropdownSelect = function DropdownSelect(props) {
  var _extends2;

  return /*#__PURE__*/React.createElement(CoreDropdownSelect, _extends({}, props, (_extends2 = {
    required: false,
    overflowEllipsis: false,
    readOnlyBorders: false,
    maxWidth: undefined,
    minWidth: undefined,
    height: calculateRem(42),
    selectPadding: calculateRem(12, 40, 12, 16),
    labelMarginBottom: calculateRem(1),
    errorLabelSpacing: calculateRem(4)
  }, _defineProperty(_extends2, "readOnlyBorders", false), _defineProperty(_extends2, "hoverState", false), _defineProperty(_extends2, "maxWidth", undefined), _defineProperty(_extends2, "minWidth", undefined), _defineProperty(_extends2, "required", true), _defineProperty(_extends2, "iconConfig", IconData), _defineProperty(_extends2, "bodyConfig", BodyConfig), _defineProperty(_extends2, "color", colors), _defineProperty(_extends2, "typescale", TypographyConfig.getTypescale()), _defineProperty(_extends2, "Body", Body), _defineProperty(_extends2, "Micro", Micro), _defineProperty(_extends2, "helperText", undefined), _defineProperty(_extends2, "helperTextPlacement", undefined), _defineProperty(_extends2, "Tooltip", undefined), _defineProperty(_extends2, "tooltipTitle", undefined), _defineProperty(_extends2, "tooltipContent", undefined), _defineProperty(_extends2, "inlineLabel", false), _extends2)));
};

export default DropdownSelect;